import AOS from "aos";
import axios from "axios";
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
import Rellax from "rellax";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const apiURL = "https://le11desbouchaux.fr/wp-json/wp/v2/";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

// Sens du scroll
let previousScrollPosition = 0;
let header = document.querySelector("#header-simple");

window.addEventListener("DOMContentLoaded", () => {
	initWidthBouton();
	initSmooth();
	initRellax();
	initBlog();
	initSwiper();
	initNoteMoyenne();
	initHeader();
	initAnimations();
	initTemoins();
	initPlats();
	initAOS(); // Initie AOS (afin intégration des classes de Théo)
});

window.addEventListener(
	"scroll",
	function (e) {
		if (window.scrollY > 90) {
			document.getElementById("header").classList.add("flottant");
			document.getElementById("header-mobile").classList.add("flottant");
		} else {
			document.getElementById("header").classList.remove("flottant");
			document.getElementById("header-mobile").classList.remove("flottant");
		}
		if (isScrollingDown() && window.scrollY > 90) {
			document.getElementById("header").classList.add("hidden");
		} else {
			document.getElementById("header").classList.remove("hidden");
		}
	},
	{ passive: true }
);

const initPlats = () => {
	let plats = document.querySelectorAll(".les-plats");
	if (plats) {
		plats.forEach((el) => {
			let barre = el.querySelector(".barre");
			barre.addEventListener("click", () => {
				el.classList.toggle("active");
			});
		});
	}
};
const initWidthBouton = () => {
	let boutons = document.querySelectorAll(".bouton");
	if (boutons) {
		boutons.forEach((el) => {
			el.style.maxWidth = el.clientWidth + "px";
		});
	}
};
const initSmooth = () => {
	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			e.preventDefault();
			document.querySelector(this.getAttribute("href")).scrollIntoView({
				behavior: "smooth",
			});
		});
	});
	let smoother = ScrollSmoother.create({
		smoothTouch: 0.1,
		smooth: 1.7,
		effects: true,
	});
};
// UTILITAIRE : le haut de l'élément est-il dans l'écran ? Boolean
const isScrollingDown = () => {
	let goingDown = false;
	let scrollPosition = window.pageYOffset;
	if (scrollPosition > previousScrollPosition) {
		goingDown = true;
	}
	previousScrollPosition = scrollPosition;
	return goingDown;
};
// UTILITAIRE : l'élément est-il dans l'écran, même partiellement ? Boolean
const elementIsPartiallyInViewport = (el) => {
	var top = el.offsetTop;
	var left = el.offsetLeft;
	var width = el.offsetWidth;
	var height = el.offsetHeight;
	while (el.offsetParent) {
		el = el.offsetParent;
		top += el.offsetTop;
		left += el.offsetLeft;
	}
	return (
		top < window.pageYOffset + window.innerHeight &&
		left < window.pageXOffset + window.innerWidth &&
		top + height > window.pageYOffset &&
		left + width > window.pageXOffset
	);
};
// UTILITAIRE : est-ce que le terminal supporter la gestuelle

const initAOS = () => {
	AOS.init({
		offset: 0,
		delay: 200,
		easing: "ease-out",
		duration: 1000,
		mirror: false,
		once: true,
	});
};
const initRellax = () => {
	var rellax = new Rellax(".rellax", {
		center: true,
	});
};
const initSwiper = () => {
	let galeries = document.querySelectorAll(".galerie-swiper");
	let promos = document.querySelector("#promo-messages");
	if (galeries) {
		galeries.forEach((el) => {
			const swiper = new Swiper(el, {
				centeredSlides: true,
				direction: "horizontal",
				loop: true,
				speed: 400,
				grabCursor: true,
				breakpoints: {
					280: {
						slidesPerView: "auto",
						spaceBetween: 0,
					},
					980: {
						slidesPerView: 3,
						spaceBetween: 0,
					},
				},
			});

			swiper.on("touchStart", () => {
				el.classList.add("changing");
			});
			swiper.on("touchEnd", () => {
				el.classList.remove("changing");
			});
		});
	}
	if(promos) {
		const swiper_promos = new Swiper("#promo-messages .swiper-promo", {
			loop: true,
			speed: 400,
			autoplay: {
				delay: 7000,
			},
			slidesPerView: 1,
		});
	}
};
const initAnimations = () => {
	// FOOTER
	const footer = document.getElementById("footer");
	const end_footer = footer.querySelector(".end .container");
	const separator = footer.querySelector(".end .separator");

	// gsap.utils.toArray(".hero").forEach((section) => {
	// 	let tl = gsap.timeline({
	// 		scrollTrigger: {
	// 			trigger: section,
	// 			start: "top top",
	// 			end: () => "+=" + section.offsetWidth,
	// 			scrub: 1.5,
	// 		},
	// 	});
	// 	// animate the container one way...
	// 	tl.fromTo(section.querySelector(".bg"), { top: "-15%" }, { top: "15%" });
	// });

	// SEPARATEURS
	gsap.utils.toArray(".acf-block.separateur").forEach((section) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: section,
				start: "top center",
				end: () => "+=" + section.offsetHeight / 1.5,
				scrub: 1,
				markers: false,
				refreshPriority: 1,
			},
			onComplete: () => {
				//ScrollTrigger.refresh();
			},
		});
		// animate the container one way...
		tl.fromTo(
			section,
			{ maxWidth: "80%", width: document.querySelector(".container").offsetWidth + "px", borderRadius: "20px" },
			{ maxWidth: "100%", width: "100%", borderRadius: "0px" }
		);
	});

	// gsap.utils.toArray(".cta").forEach((section) => {
	// 	let tl = gsap.timeline({
	// 		scrollTrigger: {
	// 			trigger: section,
	// 			start: "top center",
	// 			end: () => "+=" + section.offsetWidth,
	// 			scrub: 3,
	// 		},
	// 	});
	// 	// animate the container one way...
	// 	tl.fromTo(section.querySelector(".main-image"), { top: "-20%" }, { top: "10%" });
	// });

	gsap.utils.toArray(".comparison").forEach((section) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: section,
				start: "center center",
				end: () => "+=" + section.offsetWidth * 0.9,
				scrub: 0.5,
				pin: ".avantapres",
				refreshPriority: 1,
				//pinSpacing: false,
			},
			onComplete: () => {
				ScrollTrigger.refresh();
			},
			defaults: { ease: "none" },
		});
		// animate the container one way...
		tl.fromTo(section.querySelector(".beforeImage"), { opacity: 1 }, { opacity: 0 });
	});

	gsap.fromTo(
		separator,
		{
			height: 0,
		},
		{
			height: 180,
			scrollTrigger: {
				scrub: 1,
				trigger: separator,
				start: "bottom 80%",
				end: "+=400",
			},
		}
	);
	gsap.fromTo(
		end_footer,
		{
			y: 100,
			opacity: 0,
		},
		{
			y: 0,
			opacity: 1,
			scrollTrigger: {
				scrub: 1,
				trigger: end_footer,
				end: "+=" + end_footer.offsetHeight,
			},
		}
	);
	ScrollTrigger.refresh();
};
const initBlog = () => {
	let blog = document.querySelector(".blog");
	let filters = document.querySelectorAll(".global-blog .filters ul li");
	let iso;
	if (blog) {
		iso = new Isotope(blog, {
			itemSelector: ".article",
		});
	}
	if (filters) {
		filters.forEach((el) => {
			el.addEventListener("click", () => {
				filters.forEach((li) => {
					li.classList.remove("selected");
				});
				el.classList.toggle("selected");
				let selected_items = document.querySelector(".global-blog .filters ul li.selected");
				if (selected_items) {
					iso.arrange({ filter: "." + selected_items.dataset.slug });
				} else {
					iso.arrange({ filter: "*" });
				}
			});
		});
	}
};
const initTemoins = () => {
	let toggle_form = document.getElementById("toggleForm");
	let avisform = document.getElementById("leformavis");
	if (toggle_form && avisform) {
		toggle_form.addEventListener("click", () => {
			avisform.classList.toggle("visible");
			setTimeout(() => {
				ScrollTrigger.refresh();
			}, 500);
		});
	}
	if (document.getElementById("lescommentaires")) {
		var commentaires = new Vue({
			el: "#lescommentaires",
			data: {
				count: 1,
				precedent: "Precédent",
				next: "Suivant",
				ready: false,
				avis: [],
				stillmore: false,
				nextpage: 1,
				pagecurrent: 1,
				avis_total: 0,
				total_pages: 1,
			},
			created() {
				axios({
					url: apiURL + "avis",
					method: "GET",
					params: {
						per_page: 99,
					},
				}).then((res) => {
					this.avis_total = res.data.length;
					this.total_pages = Math.ceil(this.avis_total / 3);
					axios({
						url: apiURL + "avis",
						method: "GET",
						params: {
							page: 1,
							per_page: 3,
						},
					}).then((res) => {
						this.ready = true;
						this.avis = res.data;
						setTimeout(() => {
							ScrollTrigger.refresh();
						}, 200);
					});
				});
			},
			methods: {
				changePage(page) {
					this.ready = false;
					axios({
						url: apiURL + "avis",
						method: "GET",
						params: {
							page: page,
							per_page: 3,
						},
					}).then((res) => {
						this.pagecurrent = page++;
						this.avis = res.data;
						this.ready = true;
						setTimeout(() => {
							ScrollTrigger.refresh();
						}, 200);
					});
				},
			},
		});
	}
};
const initNoteMoyenne = () => {
	let module_note = document.getElementById("note_moyenne");
	if (module_note) {
		var module = new Vue({
			el: "#note_moyenne",
			data: {
				note_moyenne: 5,
				nb_utilisateurs: 0,
				ready: false,
			},
			created() {
				axios({
					url: apiURL + "avis",
					method: "GET",
					params: {
						per_page: 999,
					},
				}).then((res) => {
					let subtotal = 0;
					res.data.forEach((el) => {
						subtotal += parseInt(el.acf.note);
					});
					this.note_moyenne = subtotal / res.data.length;
					this.nb_utilisateurs = res.data.length;
					this.ready = true;
					setTimeout(() => {
						ScrollTrigger.refresh();
					}, 200);
				});
			},
			methods: {
				changePage(page) {
					this.ready = false;
					axios({
						url: apiURL + "avis",
						method: "GET",
						params: {
							page: page,
							per_page: 3,
						},
					}).then((res) => {
						this.pagecurrent = page++;
						this.avis = res.data;
						this.ready = true;
						setTimeout(() => {
							ScrollTrigger.refresh();
						}, 200);
					});
				},
			},
		});
	}
};
const initHeader = () => {
	let header_mobile = document.getElementById("header-mobile");
	if (header_mobile) {
		let burger = header_mobile.querySelector("#hamburger");
		burger.addEventListener("click", () => {
			header_mobile.classList.toggle("open");
		});
	}
};

(function ($) {})(jQuery);
